module.exports = __webpack_public_path__ + "static/media/1014662.878f3e79.jpg";